import ProductionLineOverview from './ProductionLineOverview';
import ProductionLineTabs from './ProductionLineTabs';
import ProductionLineCosts from './ProductionLineCosts';
import ProductionLineItems from './ProductionLineItems';
import ProductionLineLogs from './ProductionLineLogs';
import ProductionLineSummary from './ProductionLineSummary';

export { 
  ProductionLineOverview,
  ProductionLineTabs,
  ProductionLineCosts,
  ProductionLineItems,
  ProductionLineLogs,
  ProductionLineSummary
};

export const LineProductionTabs = ProductionLineTabs;
